

import {Component, Vue} from "vue-property-decorator"

@Component({})
export default class Cv extends Vue {
  name!: "cv"
}
